import api from "./api";

const BASE_ENDPOINT = '/rotina';

/**
 * Inicia o cron de fechamento automático
 * @param {number} diaUtil - Dia útil do mês (5 ou 11)
 */
function iniciarFechamentoAutomatico(diaUtil) {
    return api.post(`${BASE_ENDPOINT}/fechamento`, { diaUtil });
}

/**
 * Verifica o status do cron de fechamento automático
 * Não envia payload, apenas recebe a resposta com o status
 * @param {Object} config - Configuração opcional do axios (ex: { signal }) para cancelamento de requisição
 */
function verificarAndamentoFechamento(config = {}) {
    return api.get(`${BASE_ENDPOINT}/status`, config);
}

/**
 * Executa notificação de divergência de horas PontoTwo x Jira para o mês atual
 */
function notificacaoPonto() {
    return api.get(`${BASE_ENDPOINT}/notificacao-ponto`);
}

/**
 * Executa notificação de divergência de horas PontoTwo x Jira para o mês anterior
 */
function notificacaoPontoMesAnterior() {
    return api.get(`${BASE_ENDPOINT}/notificacao-ponto-mes-anterior`);
}

/**
 * Inicia manualmente a apuração de horas extras
 */
function apuracaoHoraExtra() {
    return api.post(`${BASE_ENDPOINT}/apuracaoHoraExtra`);
}

const RotinaApiService = {
    iniciarFechamentoAutomatico,
    verificarAndamentoFechamento,
    notificacaoPonto,
    notificacaoPontoMesAnterior,
    apuracaoHoraExtra
}

export default RotinaApiService;

